import * as React from "react";
import MoreOverlay from "./moreOverlay";
import MultiMedia from "./multiMedia";
import getFirstVideoIndex from "../helper/getFirstVideoIndex";
// styles

const styles = require("./portraitPlaceholder.scss");

interface IPortraitPlaceholderProps {
  summaryData: Array<
    Vingle.CardContent.ImageContentData | Vingle.CardContent.VideoContentData
  >;
  componentWidth: number;
  componentHeight: number;
}

class PortraitPlaceholder extends React.PureComponent<
  IPortraitPlaceholderProps
> {
  public render() {
    const { summaryData } = this.props;

    if (summaryData.length === 1) {
      return this.oneImageContainer();
    } else if (summaryData.length === 2) {
      return this.twoImageContainer();
    } else if (summaryData.length === 3) {
      return this.threeImageContainer();
    } else if (summaryData.length === 4) {
      return this.fourImageContainer();
    } else if (summaryData.length > 4) {
      return this.fourImageContainer(true);
    } else {
      return null;
    }
  }

  private readonly oneImageContainer = () => {
    const data = this.props.summaryData[0];
    const { componentWidth, componentHeight } = this.props;
    const height = Math.min(
      Math.floor(
        (componentWidth * this.props.summaryData[0].height) /
          this.props.summaryData[0].width,
      ),
      componentHeight * 1.2,
    );
    const style = {
      width: componentWidth,
      height,
    };

    return (
      <div className={`${styles.typeOne} ${styles.item}`} style={style}>
        <MultiMedia
          data={data}
          width={componentWidth}
          height={height}
          autoPlay={getFirstVideoIndex(this.props.summaryData) === 0}
        />
      </div>
    );
  };

  private readonly twoImageContainer = () => {
    const { componentWidth, componentHeight, summaryData } = this.props;

    return (
      <div
        className={styles.twoImageWrapper}
        style={{
          width: this.props.componentWidth,
          height: this.props.componentHeight,
        }}
      >
        <div
          className={`${styles.item} ${styles.topLeft} ${styles.bottomLeft}`}
          style={{
            width: componentWidth / 2,
            height: componentHeight,
          }}
        >
          <MultiMedia
            width={componentWidth / 2}
            height={componentHeight}
            data={summaryData[0]}
            className={`${styles.topLeft} ${styles.bottomLeft}`}
            autoPlay={getFirstVideoIndex(this.props.summaryData) === 0}
          />
        </div>
        <div
          className={`${styles.item} ${styles.marginLeft} ${styles.topRight} ${
            styles.bottomRight
          }`}
          style={{
            width: componentWidth / 2,
            height: componentHeight,
          }}
        >
          <MultiMedia
            width={componentWidth / 2}
            height={componentHeight}
            data={summaryData[1]}
            className={`${styles.topRight} ${styles.bottomRight}`}
            autoPlay={getFirstVideoIndex(this.props.summaryData) === 1}
          />
        </div>
      </div>
    );
  };

  private readonly threeImageContainer = () => {
    const { componentWidth, componentHeight, summaryData } = this.props;

    return (
      <div
        className={styles.threeImageWrapper}
        style={{
          width: this.props.componentWidth,
          height: this.props.componentHeight,
        }}
      >
        <div
          className={`${styles.item} ${styles.left} ${styles.topLeft} ${
            styles.bottomLeft
          }`}
          style={{
            width: componentWidth / 2,
            height: componentHeight,
          }}
        >
          <MultiMedia
            width={componentWidth / 2}
            height={componentHeight}
            data={summaryData[0]}
            className={`${styles.topLeft} ${styles.bottomLeft}`}
            autoPlay={getFirstVideoIndex(this.props.summaryData) === 0}
          />
        </div>
        <div
          className={`${styles.right} ${styles.marginLeft} ${styles.topRight} ${
            styles.bottomRight
          }`}
        >
          <div
            className={`${styles.item} ${styles.marginBottom} ${
              styles.topRight
            }`}
            style={{
              width: componentWidth / 2,
              height: componentHeight / 2,
            }}
          >
            <MultiMedia
              width={componentWidth / 2}
              height={componentHeight / 2}
              data={summaryData[1]}
              className={styles.topRight}
              autoPlay={getFirstVideoIndex(this.props.summaryData) === 1}
            />
          </div>
          <div
            className={`${styles.item} ${styles.bottomRight}`}
            style={{
              width: componentWidth / 2,
              height: componentHeight / 2,
            }}
          >
            <MultiMedia
              width={componentWidth / 2}
              height={componentHeight / 2}
              data={summaryData[2]}
              className={styles.bottomRight}
              autoPlay={getFirstVideoIndex(this.props.summaryData) === 2}
            />
          </div>
        </div>
      </div>
    );
  };

  private readonly fourImageContainer = (showMore: boolean = false) => {
    const { componentWidth, componentHeight, summaryData } = this.props;

    return (
      <div
        className={styles.fourImageWrapper}
        style={{
          width: this.props.componentWidth,
          height: this.props.componentHeight,
        }}
      >
        <div
          className={`${styles.item} ${styles.left} ${styles.topLeft} ${
            styles.bottomLeft
          }`}
          style={{
            width: (componentWidth * 2) / 3,
            height: componentHeight,
          }}
        >
          <MultiMedia
            width={(componentWidth * 2) / 3}
            height={componentHeight}
            data={summaryData[0]}
            className={`${styles.topLeft} ${styles.bottomLeft}`}
            autoPlay={getFirstVideoIndex(this.props.summaryData) === 0}
          />
        </div>
        <div
          className={`${styles.right} ${styles.marginLeft} ${styles.topRight} ${
            styles.bottomRight
          }`}
        >
          <div
            className={`${styles.item} ${styles.marginBottom} ${
              styles.topRight
            }`}
            style={{
              width: componentWidth / 3,
              height: componentHeight / 3,
            }}
          >
            <MultiMedia
              width={componentWidth / 3}
              height={componentHeight / 3}
              data={summaryData[1]}
              className={styles.topRight}
              autoPlay={getFirstVideoIndex(this.props.summaryData) === 1}
            />
          </div>
          <div
            className={`${styles.item} ${styles.marginBottom}`}
            style={{
              width: componentWidth / 3,
              height: componentHeight / 3,
            }}
          >
            <MultiMedia
              width={componentWidth / 3}
              height={componentHeight / 3}
              data={summaryData[2]}
              autoPlay={getFirstVideoIndex(this.props.summaryData) === 2}
            />
          </div>
          <div
            className={`${styles.item} ${styles.bottomRight}`}
            style={{
              width: componentWidth / 3,
              height: componentHeight / 3,
            }}
          >
            <MultiMedia
              width={componentWidth / 3}
              height={componentHeight / 3}
              data={summaryData[3]}
              className={styles.bottomRight}
              autoPlay={getFirstVideoIndex(this.props.summaryData) === 3}
              hideBadge={showMore}
            />
            {showMore ? (
              <MoreOverlay
                className={`${styles.more} ${styles.bottomRight}`}
                sizeOfRemain={summaryData.length - 4}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  };
}
export default PortraitPlaceholder;
